'use client';

import React from 'react';
import { DropdownProvider, useDropdown } from '@/context/DropdownContext';
import useBodyScrollLock from '@/hooks/useBodyScrollLock';
import {TopBar} from './TopBar';
import NavigationBar from './NavigationBar';
import { HeaderProps } from '@/page-builder/global/mappers/header.mapper';

const ScrollLockManager: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAnyDropdownOpen } = useDropdown();
  
  useBodyScrollLock(isAnyDropdownOpen);
  
  return <>{children}</>;
};

export const Header = ({topBar, menuItems, logo, ctaButton, searchTrends}: HeaderProps) => {
  return (
    <DropdownProvider>
      <ScrollLockManager>
        <header id="header-container" className="sticky top-0 z-sticky">
          <div className="agora-header">
            <TopBar searchTrends={searchTrends} topBar={ topBar } menuItems={ menuItems} />
            <NavigationBar logo={logo} ctaButton={ctaButton} menuItems={menuItems} />
          </div>
        </header>
      </ScrollLockManager>
    </DropdownProvider>
  );
};

export default Header;